import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import config from "../../config";

export default function MagazinePreview() {
  const [items, setItems] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { subcategory, id } = useParams();

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    fetch(
      `${config.apiUrl}contentapi.php?option=1&type=6&subcategory=${subcategory}&id=${id}`
    )
      .then((response) => response.json())
      .then((items) => {
        setItems(items);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, [subcategory, id]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <div
          className="spinner-border primary-text-blue"
          dir="ltr"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // error if data is not fetched
  if (error) {
    return (
      <div className="max-container-width pt-4 pb-3">
        <p className="alert alert-danger" role="alert" dir="ltr">
          Something went wrong: {error.message}
        </p>
      </div>
    );
  }

  return (
    <div className="bg-body">
      <div className="max-container-width py-3 text-body">
        {items.map((item) => (
          <div key={item.id}>
            <h3
              className="border-end border-5 pe-2"
              id="secondary-border-yellow"
            >
              {item.Title}
            </h3>
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{ __html: item.ShortDesc }}
            />
            <object
              data={item.FileUrl}
              type="application/pdf"
              style={{ width: "100%", height: "100vh" }}
            >
              <p>
                مجله قابل مشاهده نیست، در عوض{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={item.FileUrl}
                >
                  دانلود
                </a>{" "}
                کنید.
              </p>
            </object>
          </div>
        ))}
      </div>
    </div>
  );
}
